import { render, staticRenderFns } from "./StudentBasic.vue?vue&type=template&id=221775ae&"
import script from "./StudentBasic.vue?vue&type=script&lang=js&"
export * from "./StudentBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports